<template>
	<div :class="classNames">
		<div modalwrapper :class="[style.modalWrapper]" :style="{ paddingRight: (hasClose ? '28px' : '') }">
			<div :class="[style.modalContent]">
				<slot></slot>
			</div>
			<span v-if="hasClose" @click="$emit('close')" :class="closeButtonClassNames">&times;</span>
		</div>
	</div>
</template>

<!-- to do: -->
<!-- Скрытие при клике вне контента окна -->

<script>
	import style from './style.module.scss'

	export default {
		name: 'modal',
		components: {

		},
		props: {
			size: String,
			hasClose: {
				default: true
			},
			theme: {
				type: String,
				default: 'white'
			},
			closeButtonTheme: {
				type: String,
				default: 'white'
			}
		},
		data() {
			return {
				style: style
			}
		},
		computed: {
			modalSizeClass() {
				switch (this.size) {
					case 'sm':
						return this.style.modalSm
					case 'xl':
						return this.style.modalXl
					default:
						return this.style.modalMid
				}
			},
			classNames() {
				const classNames = [style.modal, this.modalSizeClass];

				switch (this.theme) {
					case 'white':
						classNames.push(this.style.modalWhite);
						break;
					case 'black':
						classNames.push(this.style.modalBlack);
						break;
				}

				return classNames;
			},
			closeButtonClassNames() {
				const closeButtonClassNames = [];

				switch (this.closeButtonTheme) {
					case 'white':
						closeButtonClassNames.push(this.style.modalCloseWhite);
						break;
					case 'black':
						closeButtonClassNames.push(this.style.modalClose);
						break;
				}

				return closeButtonClassNames;
			}
		}
	}
</script>